import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Check = createSvgIcon(React.createElement("polygon", { points: "18.2,6.1 9.3,15 5.8,11.5 4.4,12.9 7.9,16.4 7.9,16.4 9.3,17.9 19.6,7.6" }), 'Check');
export default Check;
